// extracted by mini-css-extract-plugin
export default {"area":"Privacy_area__9TGmH","header":"Privacy_header__ksJ8z","content":"Privacy_content__HcItI"};